import { reactive, onBeforeMount, computed } from 'vue';
import _ from 'lodash';
import { useI18n } from 'vue-i18n';
import { EurekaPatentService } from '../services/patent-service';
import { EurekaPaperService } from '../services/paper-service';
import messages from '@patsnap-biz/save-to-workspace-v2/src/locales';
import type { IServiceProps } from '../types/batch-save';
import { EBatchSaveType } from '../types/batch-save';

export function useSaveService(props: IServiceProps) {
    const { mergeLocaleMessage, locale, t } = useI18n();

    const saveData = computed(() => {
        return {
            solutionIds: props.solutionIds,
            total: _.size(props.solutionIds) || props.total || 0,
            conditions: props.conditions,
        }
    });

    function createServiceInstance() {
        if (props.type === EBatchSaveType.PAPER) {
            return new EurekaPaperService({
                t,
                saveData: saveData.value,
            });
        }
        return new EurekaPatentService({
            t,
            saveData: saveData.value,
        });
    }

    const service = reactive(createServiceInstance());

    function initlocaleMessage() {
        mergeLocaleMessage(locale.value, _.merge({}, messages[locale.value]));
    }

    onBeforeMount(initlocaleMessage);

    return {
        service,
    };
}
